import React from "react";
import { ChevronRight } from "lucide-react";
import { RevealOnScroll, scrollToId } from "../../marketingAgency/shared";
import { WEAPON_HOOK } from "./weaponHookContent";

const WeaponHookBanner = () => (
  <section className="relative overflow-hidden px-6 lg:px-8 pb-8 sm:pb-10" data-testid="weapon-hook-banner">
    <div className="max-w-6xl mx-auto">
      <RevealOnScroll>
        <div className="rounded-xl border border-[#00D2FF]/25 bg-[#00D2FF]/5 px-5 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="min-w-0">
            <p className="font-mono text-[10px] sm:text-xs text-partner-accent font-semibold tracking-wider mb-2">
              {WEAPON_HOOK.label}
            </p>
            <p className="text-base sm:text-lg font-bold text-partner leading-tight mb-1">{WEAPON_HOOK.headline}</p>
            <p className="text-sm text-partner-muted font-body leading-relaxed">{WEAPON_HOOK.body}</p>
          </div>
          <button
            type="button"
            onClick={() => scrollToId(WEAPON_HOOK.target)}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-partner-accent hover:text-partner transition-colors shrink-0 focus:outline-none focus:ring-2 focus:ring-[#00D2FF]/25 rounded"
          >
            {WEAPON_HOOK.cta}
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </RevealOnScroll>
    </div>
  </section>
);

export default WeaponHookBanner;
